import {CssBaseline} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {Outlet, useLocation, useNavigate} from 'react-router';
import Header from '../components/Header/Header';
import {DashboardDrawer as Drawer, Root} from '../components/StyledComponents';
import useWindowDimensions from '../utils/windowDimensions';
import {useAppSelector} from "../store/hooks";
import {IUser} from "../models/models";
import {getUserSelector, isHasProPlan, isSubUser, underWork, userRoles} from "../store/selectors";
import {Helmet} from 'react-helmet';
import OnWork from "../views/OnWork/OnWork";
import Sidebar from "../components/Sidebar/Sidebar";

const Dashboard: React.FC = ({children}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const user: IUser | null = useAppSelector(getUserSelector);
  const isUnderWork = useAppSelector(underWork);
  const [mobileOpen, setMobileOpen] = useState(true);
  const [bigMenu, setBigMenu] = useState(true);
  const isUserSub = useAppSelector(isSubUser);
  const roles = useAppSelector(userRoles);
  const hasProPlan = useAppSelector(isHasProPlan);

  const {isSmallScreenPortrait, isSmallScreen} = useWindowDimensions();

  const handleDrawerToggle = () => {
    // isSmallScreenPortrait ?
    //   setMobileOpen(!mobileOpen) :
      setBigMenu(!bigMenu);
  };

  useEffect(() => {
    if (isSmallScreen && bigMenu) {
      setBigMenu(false)
    } else if (!isSmallScreen && !bigMenu) {
      setBigMenu(true)
    }
  }, [isSmallScreen])

  useEffect(() => {
    if (isUserSub && (
      (!hasProPlan && (location.pathname.includes('platform') || location.pathname.includes('audit'))) ||
      location.pathname.includes('subscriptions') ||
      location.pathname.includes('app-connector') ||
      location.pathname.includes('checkout')
    )) {
      navigate('/', {replace: true})
    }
  }, [isUserSub, location]);

  return (
    <Root isMobile={isSmallScreenPortrait || false}>
      <Helmet>
        <title>BackupLABS</title>
        <meta name="title" content="BackupLABS"/>
        <meta name="description"
              content="BackupLABS offer an automatic and reliable SaaS backup solution for your business. Protect GitHub, Trello, GitLab, Jira and Notion apps."/>
      </Helmet>
      <CssBaseline/>
      {isUnderWork && <OnWork/>}
      {/*{isSmallScreenPortrait &&*/}
      {/*  <Header*/}
      {/*    menuToggle={handleDrawerToggle}*/}
      {/*    secondLogo={user?.hadEverAnySubscriptions || false}/>*/}
      {/*}*/}
      <Drawer bigmenu={bigMenu} onClose={handleDrawerToggle}>
        <Sidebar
          isOpen={bigMenu}
          setIsOpen={handleDrawerToggle}
          // isOpen={isSmallScreenPortrait ? mobileOpen : bigMenu}
          // isMobile={isSmallScreenPortrait}
        />
      </Drawer>
      {children}
      <Outlet/>
    </Root>
  );
};

export default Dashboard;
